import {combine} from 'effector';

import {createGate} from 'effector-react';

import {
    changePassword,
    createPasswordRequest,
    resetPasswordByAdminRequest,
    resetPasswordRequest,
    setPassword,
} from 'api/password';

import {rootDomain} from 'core/rootDomain';

import {SetPasswordRequest} from 'types/password';

const domain = rootDomain.createDomain('passwordDomain');
export const Gate = createGate('PasswordGate');

export const setPasswordFx = domain.createEffect({
    name: 'setPasswordFx',
    handler: setPassword,
});

export const resetPasswordFx = domain.createEffect({
    name: 'resetPasswordFx',
    handler: setPassword,
});

export const createPasswordRequestFx = domain.createEffect({
    name: 'createPasswordRequestFx',
    handler: createPasswordRequest,
});

export const resetPasswordRequestFx = domain.createEffect({
    name: 'resetPasswordRequestFx',
    handler: resetPasswordRequest,
});

export const resetPasswordByAdminRequestFx = domain.createEffect({
    name: 'resetPasswordByAdminRequestFx',
    handler: resetPasswordByAdminRequest,
});

export const changePasswordFx = domain.createEffect({
    name: 'changePasswordFx',
    handler: changePassword,
});

export const resetPasswordByAdminClicked = domain.createEvent<SetPasswordRequest>();

export const setPasswordResetUser = domain.createEvent<SetPasswordRequest | null>();
export const userForPasswordReset$ = domain
    .createStore<SetPasswordRequest | null>(null)
    .on(setPasswordResetUser, (_, user) => user)
    .reset(resetPasswordByAdminRequestFx.pending);

export const setExpired = domain.createEvent<boolean>();

export const error$ = domain.createStore<string | null>(null);
export const success$ = domain.createStore<boolean>(false);
export const expired$ = domain.createStore<boolean>(false);

export const state$ = combine({
    error: error$,
    success: success$,
    expired: expired$,
    pending: combine(
        [
            setPasswordFx.pending,
            resetPasswordFx.pending,
            resetPasswordRequestFx.pending,
            resetPasswordByAdminRequestFx.pending,
            changePasswordFx.pending,
            createPasswordRequestFx.pending,
        ],
        (pendingList) => pendingList.some(Boolean),
    ),
});
